/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class ToteAssistant extends Assistant {
        inner = document.createElement("div");
        group_result_container = document.createElement("div");
        tote_result_container = document.createElement("div");
        headline = document.createElement("h1");
        initialized = false;
        callback: (toteId: number) => void;
        showOnlyFree: boolean;


        constructor() {
            super();

            //setup sender screen
            this.inner.appendChild(this.headline);

            this.group_result_container.style.position = "absolute";
            this.group_result_container.style.width = "100%";
            this.group_result_container.style.bottom = "100px";
            this.group_result_container.style.top = "100px";
            this.group_result_container.style.overflowY = "scroll";
            this.group_result_container.classList.add("simple-scroll");
            this.inner.append(this.group_result_container);

            this.tote_result_container.style.position = "absolute";
            this.tote_result_container.style.width = "100%";
            this.tote_result_container.style.bottom = "100px";
            this.tote_result_container.style.top = "100px";
            this.tote_result_container.style.overflowY = "scroll";
            this.tote_result_container.classList.add("simple-scroll");
            this.inner.append(this.tote_result_container);

            this.container.appendChild(this.inner);

        }


        clear() {
            this.currentGroupId = "";
            this.tote_result_container.innerHTML = "";
            this.group_result_container.innerHTML = "";
            this.tote_result_container.style.display = "none";
            this.group_result_container.style.display = "none";

        }

        currentGroupId: string;
        currentGroupName: string;


        async openGroupMenu() {
            var groups = await SP.Data.Tote.getToteGroupInfos();
            this.headline.innerHTML = "Select Tote Group";

            for (let i = 0; i < groups.length; i++) {
                this.addGroupButton(groups[i]);
            }

            this.group_result_container.style.display = "block";
        }

        async openToteMenu(data: SP.ToteGroupInfo) {
            this.tote_result_container.innerHTML = "";
            if (this.currentGroupId != data.id) {
                this.currentGroupId = data.id;
                this.currentGroupName = data.name;
                this.headline.innerHTML = "Pick a Tote";
                this.group_result_container.innerHTML = "";
                var totes = await SP.Data.Tote.getToteInfosByGroup(this.currentGroupId, this.showOnlyFree);

                for (let i = 0; i < totes.length; i++) {
                    let order = totes[i];
                    this.addToteButton(order);

                }
            }

            this.group_result_container.style.display = "block";
        }

        async init() {
            if (this.initialized) return;
            this.initialized = true;
        }

        async open(showOnlyFree: boolean, callback: (toteId: number) => void) {
            await this.init();
            await this.clear();
            await this.openGroupMenu();
            this.callback = callback;
            this.showOnlyFree = showOnlyFree;
            this.container.style.display = "block";

        }


        close() {
            super.close();
        }


        addGroupButton(data: SP.ToteGroupInfo) {
            if (data.count <= 0) return;
            var c = this.group_result_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            // c.style.marginTop = "30px";

            //var icon = c.appendChild(document.createElement("img"));
            //icon.src = "/terminal/img/icon/open-box.png";
            //icon.classList.add("icon");

            c.style.backgroundColor = data.color;
            c.style.color = '#fff';
            c.style.textShadow = '0px 1px 4px #000'

            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = SP.Localize("word_arrival");
            action.innerHTML = "<b>" + data.name + "</b><br />";

            var name = c.appendChild(document.createElement("span"));
            name.classList.add("name");
            name.innerHTML = data.count + " Totes";

            c.addEventListener("click", () => {
                this.openToteMenu(data);
            });
        }

        addToteButton(data: SP.ToteInfo) {
            var c = this.group_result_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            //c.style.marginTop = "30px";

            var icon = c.appendChild(document.createElement("img"));
            icon.src = "/terminal/img/tote_small.png";
            icon.classList.add("icon");

            c.style.backgroundColor = data.toteColor;
            c.style.color = '#fff';
            c.style.textShadow = '0px 1px 4px #000'
            c.style.float = 'left';
            c.style.width = '23%';
            c.style.margin = '1%';
            c.style.textAlign = 'left';
            c.style.paddingLeft = '70px';
            c.style.paddingRight = '0px';

            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = SP.Localize("word_arrival");
            action.innerHTML = "<b>" + data.toteName + "</b>";


            c.addEventListener("click", () => {
                this.callback(data.toteId);
                this.close();
            });
        }

    }



}